export const GET_SETTINGS_PLANT = 'GET_SETTINGS_PLANT';
export const GET_SETTINGS_PLANT_SUCCESS = 'GET_SETTINGS_PLANT_SUCCESS';
export const GET_SETTINGS_PLANT_FAIL = 'GET_SETTINGS_PLANT_FAIL';

export const SET_SETTINGS_PLANT = 'SET_SETTINGS_PLANT';
export const SET_SETTINGS_PLANT_SUCCESS = 'SET_SETTINGS_PLANT_SUCCESS';
export const SET_SETTINGS_PLANT_FAIL = 'SET_SETTINGS_PLANT_FAIL';

/** Создание сообщений */
export const MESSAGE_CLEAR = 'MESSAGE_CLEAR';

export const MESSAGE_DELETE = 'MESSAGE_DELETE';
export const MESSAGE_DELETE_SUCCESS = 'MESSAGE_DELETE_SUCCESS';
export const MESSAGE_DELETE_FAIL = 'MESSAGE_DELETE_FAIL';

export const MESSAGE_SAVE = 'MESSAGE_SAVE';
export const MESSAGE_SAVE_SUCCESS = 'MESSAGE_SAVE_SUCCESS';
export const MESSAGE_SAVE_FAIL = 'MESSAGE_SAVE_FAIL';

export const MESSAGE_LIST = 'MESSAGE_LIST';
export const MESSAGE_LIST_SUCCESS = 'MESSAGE_LIST_SUCCESS';
export const MESSAGE_LIST_FAIL = 'MESSAGE_LIST_FAIL';

export const MESSAGE_TEMPLATE = 'MESSAGE_TEMPLATE';
export const MESSAGE_TEMPLATE_SUCCESS = 'MESSAGE_TEMPLATE_SUCCESS';
export const MESSAGE_TEMPLATE_FAIL = 'MESSAGE_TEMPLATE_FAIL';

export const MESSAGE_FILES_ADD = 'MESSAGE_FILES_ADD';
export const MESSAGE_FILES_ADD_SUCCESS = 'MESSAGE_FILES_ADD_SUCCESS';
export const MESSAGE_FILES_ADD_FAIL = 'MESSAGE_FILES_ADD_FAIL';

export const MESSAGE_FILES_DELETE = 'MESSAGE_FILES_DELETE';
export const MESSAGE_FILES_DELETE_SUCCESS = 'MESSAGE_FILES_DELETE_SUCCESS';
export const MESSAGE_FILES_DELETE_FAIL = 'MESSAGE_FILES_DELETE_FAIL';

export const MESSAGE_FILES_LIST = 'MESSAGE_FILES_LIST';
export const MESSAGE_FILES_LIST_SUCCESS = 'MESSAGE_FILES_LIST_SUCCESS';
export const MESSAGE_FILES_LIST_FAIL = 'MESSAGE_FILES_LIST_FAIL';

export const MESSAGE_READ = 'MESSAGE_READ';
export const MESSAGE_READ_SUCCESS = 'MESSAGE_READ_SUCCESS';
export const MESSAGE_READ_FAIL = 'MESSAGE_READ_FAIL';

/** Получение параметров для holder_report */
export const GET_HOLDER_SETTINGS_PLANT = 'GET_HOLDER_SETTINGS_PLANT';
export const GET_HOLDER_SETTINGS_PLANT_SUCCESS = 'GET_HOLDER_SETTINGS_PLANT_SUCCESS';
export const GET_HOLDER_SETTINGS_PLANT_FAIL = 'GET_HOLDER_SETTINGS_PLANT_FAIL';

/** Перевод состояний okPhotoAdd и okPhotoDelete в false */
export const MESSAGE_OK_PHOTO_INIT = 'MESSAGE_OK_PHOTO_INIT';

export const SET_SETTINGS_TN_PLANT = 'SET_SETTINGS_TN_PLANT';
export const SET_SETTINGS_TN_PLANT_SUCCESS = 'SET_SETTINGS_TN_PLANT_SUCCESS';
export const SET_SETTINGS_TN_PLANT_FAIL = 'SET_SETTINGS_TN_PLANT_FAIL';
